import React from 'react'
import styles from '../AdminDashboard.module.scss'

interface ConfirmDialogProps {
  isOpen: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  isDanger?: boolean
  onConfirm: () => void
  onCancel: () => void
  isLoading?: boolean
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isDanger = false,
  onConfirm,
  onCancel,
  isLoading = false,
}) => {
  if (!isOpen) return null

  return (
    <div className={styles.dialogOverlay} onClick={onCancel}>
      <div className={styles.dialogContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <h3 className={isDanger ? styles.dialogTitleDanger : ''}>{title}</h3>
        </div>
        <div className={styles.dialogBody}>
          <p>{message}</p>
        </div>
        <div className={styles.dialogFooter}>
          <button className={styles.cancelButton} onClick={onCancel} disabled={isLoading}>
            {cancelLabel}
          </button>
          <button
            className={isDanger ? styles.dangerButton : styles.confirmButton}
            onClick={onConfirm}
            disabled={isLoading}>
            {isLoading ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
